import useInputWithReset from '../../input-hooks/useInputWithReset'

import { confidentialBikeNotesForm as form } from '../../../forms/form-objects/bikeFormObjects'

import {
  getInput,
  getValidation,
  getForm,
  applyOverrides
} from '../../input-hooks/inputFunctions'

const useConfidentialBikeNotesForm = (record, fieldOverrides) => {
  applyOverrides('Bike Notes', form, fieldOverrides)
  const keyArray = Object.keys(form)
  const i = []

  i[i.length] = useInputWithReset(
    getInput(form, keyArray, i.length, record),
    getValidation(form, keyArray, i.length)
  )

  return getForm(keyArray, i)
}

export default useConfidentialBikeNotesForm
